import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { RouterModule, Routes } from '@angular/router'
import { GbGuestLoggedInGuard } from 'libs/gb-front/auth/util-auth-guards/src'
import { GbLoginComponent } from './gb-login/gb-login.component'

export class AuthConstants {
  public static LOGIN = 'login'
  public static REGISTER = 'register'
  public static VERIFY = 'verify'
  public static ADDITIONAL_INFO = 'additional-info'
  public static PRE_AUTH = 'pre-auth'
  public static REGISTER_SUCCESS = 'register-success'
  public static FORGOT_PASSWORD = 'forgot-password'
  public static VERIFY_NOTIFICATION = 'verify-notification'
  public static VOLUNTEER = 'vol'
}

const routes: Routes = [
  {
    path: '',
    canActivate: [GbGuestLoggedInGuard],
    component: GbLoginComponent,
  },
  { path: '**', component: GbLoginComponent },
]

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes), CommonModule],
})
export class GbFrontAuthLoginFeatureRoutingModule {}
